import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectStatus, Vessel } from 'icreate/common/models/vessel';
import dayjs from 'dayjs';
import { FOLDER_CREATED, PublishedVersion } from 'icreate/common/models/versions-history';

@Component({
    selector: 'app-versions-history-sidebar',
    templateUrl: './versions-history-sidebar.component.html',
    styleUrls: ['./versions-history-sidebar.component.css'],
    standalone: false,
})
export class VersionsHistorySidebarComponent implements OnInit {
    @Input() urlState: any;
    @Input() vessel: Vessel;
    @Input() versionsList: PublishedVersion[];
    @Output() onVersionSelected: EventEmitter<PublishedVersion> = new EventEmitter();
    @Output() onRestoreVersion: EventEmitter<PublishedVersion> = new EventEmitter();

    @ViewChild('optionsRef') optionsRef: ElementRef;

    readonly folderCreated = FOLDER_CREATED;

    selectedVersion: PublishedVersion;

    openedOptionVersion: string;

    constructor(private router: Router) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (!this.optionsRef?.nativeElement.contains(event.target) && this.openedOptionVersion) {
            this.openedOptionVersion = undefined;
        }
    }

    ngOnInit(): void {
        this.selectVersion(this.versionsList[0]);
    }

    async goBack() {
        if (this.urlState?.origin && this.urlState?.origin == 'version-dialog') {
            await this.router.navigateByUrl(`home/${this.vessel.shipyardId}/${this.vessel.id}`, {
                state: { origin: 'version-dialog' },
            });
            return;
        } else if (this.urlState?.origin && this.urlState?.origin == 'new-vessel-home') {
            await this.router.navigateByUrl(`home`, {
                state: { origin: 'new-vessel' },
            });
            return;
        }
        await this.router.navigateByUrl(`home/${this.vessel.shipyardId}/${this.vessel.id}`);
    }

    formatVersionDate(date) {
        if (!date) {
            return '';
        }
        return dayjs(date).format('MMM DD, YYYY, HH:mm:ss');
    }

    selectVersion(version: PublishedVersion) {
        this.selectedVersion = version;
        this.onVersionSelected.emit(version);
    }

    openOptions(versionName) {
        if (this.projectIsActive()) return;
        if (this.openedOptionVersion && this.openedOptionVersion === versionName) {
            this.openedOptionVersion = null;
            return;
        }
        this.openedOptionVersion = versionName;
    }

    projectIsActive(): boolean {
        return this.vessel.projectStatus != ProjectStatus.undefined;
    }

    restoreVersion(version) {
        this.onRestoreVersion.emit(version);
    }
}
